import { keyframes } from '@vanilla-extract/css';
import { responsiveStyle } from '../responsive/responsive-style';
import { themeVars } from '../theme/vars.ts';
import { borderRadius, space } from '../tokens.ts';
import { typography } from '../typography';
import { fadeIn } from '../animations.css';
import { style } from '../layer.css';

const contentSlideIn = keyframes({
  from: {
    opacity: 0,
    transform: 'translate(-50%, -48%) scale(0.96)',
  },
  to: {
    opacity: 1,
    transform: 'translate(-50%, -50%) scale(1)',
  },
});

export const modalContentContainer = style({
  position: 'fixed',
  display: 'flex',
  overflow: 'hidden',
  padding: 0,
  backgroundColor: themeVars.container.primary.background.idle,

  ...responsiveStyle({
    mobile: {
      inset: 0,
      animation: `${fadeIn} 150ms`,
      borderRadius: 0,
    },
    tablet: {
      inset: 'unset',
      borderRadius: borderRadius.r16,

      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90vw',
      maxWidth: '640px',
      maxHeight: '90vh',

      animation: `${contentSlideIn} 150ms`,
    },
  }),
});

export const modalContent = style({
  overflow: 'auto',
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  scrollbarGutter: 'stable',
  padding: `${space.s30}px ${space.s24}px`,
});

export const modalOverlay = style({
  backgroundColor: 'rgba(21, 12, 52, 0.55)',
  position: 'fixed',
  inset: 0,
  backdropFilter: 'blur(8px)',
  animation: `${fadeIn} 150ms`,
});

export const modalHeader = style({
  display: 'flex',
  position: 'relative',
  marginBottom: space.s24,
  alignItems: 'center',
});

export const modalHeaderWithCloseIcon = style({
  paddingRight: space.s40,
});

export const modalClose = style({
  position: 'absolute',
  right: 0,
});

export const modalTitle = style({
  ...typography['titleLg'],
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
});

export const modalHeaderStepper = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
    marginBottom: space.s4,
  },
]);
